import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import PasswordRevealWithoutForwardedType from '../new-password/PasswordRevealWithoutForwardedType';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';

const propTypes = {
    errorMessage: PropTypes.array,
    workflowNavElementId: PropTypes.string,
    secondaryButtonUrl: PropTypes.string
};
class IdentityContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ssn: '',
            dateOfBirth: '',
            zipCode: '',
            errorMessage: props.errorMessage,
            formIsValid: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    returnNumbersOnly(numberStr) {
        return numberStr.replace(/\D/g, '');
    }

    // Validation is simple here as it must have a match in the system.
    ssnIsValid(ssn) {
        // Remove everything but numbers, check length.
        return this.returnNumbersOnly(ssn).length === 9;
    }
    buildFormatStringSegment(length, letter) {
        return new Array(length)
            .fill('')
            .map(() => letter)
            .join('');
    }

    // Provides the appropriate formatString to moment, based off the input,
    // to avoid Date() fallback warning
    getDateFormatString(dateTuple) {
        let monthFormat = this.buildFormatStringSegment(dateTuple[0].length, 'M');
        let dayFormat = this.buildFormatStringSegment(dateTuple[1].length, 'D');
        let yearFormat = this.buildFormatStringSegment(dateTuple[2].length, 'Y');

        return `${monthFormat}/${dayFormat}/${yearFormat}`;
    }

    // Split the date of birth by slashes, if three parts exist get a format string and validate with Moment
    dateOfBirthIsValid(dateOfBirth) {
        let cleanDOB = dateOfBirth.replace(/[.\-\s]/g, '/');

        let destructuredDOB = cleanDOB.split('/');

        if (cleanDOB.length >= 6 && cleanDOB.indexOf('/') === -1) {
            this.setState({ errorMessage: ['Please enter Date Of Birth in format: mm/dd/yyyy'] });
            return false;
        }

        if (destructuredDOB.length === 3) {
            let formatString = this.getDateFormatString(destructuredDOB);
            return dayjs(cleanDOB, formatString).isValid();
        }

        return false;
    }
    zipCodeIsValid(zipCode) {
        return zipCode.length >= 5;
    }
    validateForm() {
        let { ssn, dateOfBirth, zipCode } = this.state;
        const isValid =
            this.ssnIsValid(ssn) &&
            this.dateOfBirthIsValid(dateOfBirth) &&
            this.zipCodeIsValid(zipCode);
        var newState = {
            formIsValid: isValid
        };

        if (isValid) {
            newState.errorMessage = [];
        }
        this.setState(newState);
    }
    handleInputChange(event) {
        const id = event.target.id;
        const value = event.target.value;
        this.setState({ [id]: value }, this.validateForm);
    }

    render() {
        let { secondaryButtonUrl, workflowNavElementId } = this.props;
        let { errorMessage, formIsValid } = this.state;

        return (
            <div>
                <div>
                    {errorMessage && (
                        <div className="is-warning">
                            <p className="asc-form-help">{errorMessage}</p>
                        </div>
                    )}
                    <div className="asc-form-group">
                        <PasswordRevealWithoutForwardedType
                            classes="asc-form-input"
                            onChange={this.handleInputChange}
                            placeholder="XXX-XX-XXXX"
                            id="ssn"
                            name="ssn"
                            label="Social Security Number"
                            preventAutofill
                            pattern="^(?!000|666)[0-9]{3}([-]?)(?!00)[0-9]{2}\u(?!0000)[0-9]{4}$"
                            required
                        />
                    </div>
                    <div className="asc-form-group">
                        <label className="asc-form-label" htmlFor="dateOfBirth">
                            Date of Birth
                        </label>
                        <p className="asc-form-subtext">Format: mm/dd/yyyy</p>
                        <input
                            className="asc-form-input"
                            onChange={this.handleInputChange}
                            placeholder="MM/DD/YYYY"
                            id="dateOfBirth"
                            type="text"
                            name="dateOfBirth"
                            pattern="^\d{1,2}(\/|-|\.)\d{1,2}(\/|-|\.)\d{2,4}$"
                            required
                        />
                    </div>
                    <div className="asc-form-group">
                        <label className="asc-form-label" htmlFor="zipCode">
                            Zip Code
                        </label>
                        <input
                            className="asc-form-input"
                            onChange={this.handleInputChange}
                            id="zipCode"
                            type="text"
                            name="zipCode"
                            pattern="[A-Za-z0-9\s-]*"
                            required
                        />
                    </div>
                </div>
                <WorkflowNavContainer
                    secondaryButtonUrl={secondaryButtonUrl}
                    primaryButtonSubmitEnabled={formIsValid}
                    elementId={workflowNavElementId}
                />
            </div>
        );
    }
}
IdentityContainer.propTypes = propTypes;
export default IdentityContainer;
